import {
    TRANSACTION_ATTACHMENT_RESPONSE,
    CLEAR_TRANSACTION_ATTACHMENT_RESPONSE
} from "../action";
import { transactionAttachmentResponse } from "./initial-store";

const initialState = transactionAttachmentResponse;

function transactionAttachmentResponseReducer(state = initialState, action) {
    let newState;
    switch (action.type) {
        case TRANSACTION_ATTACHMENT_RESPONSE:
            newState = action.payload;
            return newState;

        case CLEAR_TRANSACTION_ATTACHMENT_RESPONSE:
            newState = initialState;
            return newState;

        default:
            return state;
    }
}

export default transactionAttachmentResponseReducer;